/* eslint-disable */
import React, { Component } from 'react';
import Clipboard from '../../../node_modules/clipboard/dist/clipboard';
import classNames from 'classnames';

class CopyToClipboard extends Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
  }

  componentDidMount() {
    const clipboard = new Clipboard(this.el);
    let to = null;
    clipboard.on('success', () => {
      this.setState({ copied: true });
      clearTimeout(to);
      to = setTimeout(() => {
        this.setState({ copied: false });
      }, 2000);
    });
  }

  render() {
    const cName = classNames('tes-copy-to-clipboard', this.props.className, {
      'tes-copy-to-clipboard--copied': this.state.copied,
    });
    return (
      <div
        ref={el => (this.el = el)}
        className={cName}
        data-clipboard-text={this.props.clipboardText}
      >
        {this.props.children}
      </div>
    );
  }
}

export default CopyToClipboard;
